<template>
  <v-container fluid class="icons-page">
    <v-row no-gutters class="d-flex justify-space-between mt-5 mb-6 ">
        <v-row>
 <v-col cols="12"  >
      <iframe        
        scroll src="/Download/manual.pdf"
      ></iframe>
    </v-col>
        </v-row>
    
    </v-row>
  </v-container>
</template>

<script>
export default {}
</script>

<style  scoped>
iframe {
    display: block;       /* iframes are inline by default */
    background: #000;
    border: none;         /* Reset default border */
    height: 100vh;        /* Viewport-relative units */
    width: 75vw;
}
</style></style>
